'use client'

import React from 'react'
import AnimatedSection from '@/components/AnimatedSection'
import Typography from '@/components/Typography'
import styles from './styles.module.css'

const Decision: React.FC = () => {
	return (
		<section className={styles.section}>
			<AnimatedSection animation='slideUp'>
				<div className={styles.heading}>
					<Typography variant='h4' color='accent' className={styles.subtitle}>
						Решение
					</Typography>
					<h2
						className={styles.title}
						dangerouslySetInnerHTML={{
							__html: '<span>Нужны разработчики — без найма в штат,</span> лишних затрат и месяцев поиска'
						}}
					/>
				</div>
			</AnimatedSection>
			<AnimatedSection animation='slideUp'>
				<div className={styles.grid}>
					<article className={styles.card}>
						<Typography variant='h4' color='accent' className={styles.cardSubtitle}>
							Ваша боль
						</Typography>
						<Typography variant='p1' color='description' className={styles.cardDescription}>
							Держать разработчика в штате на полную ставку имеет смысл, когда у него есть загрузка каждый день. Но так бывает не всегда. Проект на три месяца, пиковая нагрузка, задача которую некому закрыть — в этих ситуациях аутстаффинг работает точнее и дешевле, чем найм сотрудников.
						</Typography>
					</article>
					<article className={styles.card}>
						<Typography variant='h4' color='accent' className={styles.cardSubtitle}>
							Наше решение
						</Typography>
						<Typography variant='p1' color='description' className={styles.cardDescription}>
							Мы предоставляем разработчиков и команды из собственного кадрового резерва. Вы платите за отработанные часы, управляете специалистами напрямую и не берёте на себя никаких обязательств по трудоустройству.
						</Typography>
					</article>
				</div>
			</AnimatedSection>
		</section>
	)
}

Decision.displayName = 'Decision'

export default Decision
